import { render, staticRenderFns } from "./DetalheNoticia.vue?vue&type=template&id=ed358400&scoped=true"
import script from "./DetalheNoticia.vue?vue&type=script&lang=js"
export * from "./DetalheNoticia.vue?vue&type=script&lang=js"
import style0 from "./DetalheNoticia.vue?vue&type=style&index=0&id=ed358400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed358400",
  null
  
)

export default component.exports